/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, FormText, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, isNumber, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getHospitals } from 'app/entities/hospital/hospital.reducer';
import { getEntities as getHospitalInstitutions } from 'app/entities/hospital-institution/hospital-institution.reducer';
import { createEntity, getEntity, reset, updateEntity } from './payment-community.reducer';

export const PaymentCommunityUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const hospitals = useAppSelector(state => state.hospital.entities);
  const hospitalInstitutions = useAppSelector(state => state.hospitalInstitution.entities);
  const paymentCommunityEntity = useAppSelector(state => state.paymentCommunity.entity);
  const loading = useAppSelector(state => state.paymentCommunity.loading);
  const updating = useAppSelector(state => state.paymentCommunity.updating);
  const updateSuccess = useAppSelector(state => state.paymentCommunity.updateSuccess);

  const handleClose = () => {
    navigate(`/payment-community${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getHospitals({}));
    dispatch(getHospitalInstitutions({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }
    if (values.lastUpdated !== undefined && typeof values.lastUpdated !== 'number') {
      values.lastUpdated = Number(values.lastUpdated);
    }
    if (values.microSec !== undefined && typeof values.microSec !== 'number') {
      values.microSec = Number(values.microSec);
    }
    if (values.timestampEntry !== undefined && typeof values.timestampEntry !== 'number') {
      values.timestampEntry = Number(values.timestampEntry);
    }

    const entity = {
      ...paymentCommunityEntity,
      ...values,
      hospital: hospitals.find(it => it.id.toString() === values.hospital?.toString()),
      institution: hospitalInstitutions.find(it => it.id.toString() === values.institution?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          ...paymentCommunityEntity,
          hospital: paymentCommunityEntity?.hospital?.id,
          institution: paymentCommunityEntity?.institution?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tinyMedicRestApp.paymentCommunity.home.createOrEditLabel" data-cy="PaymentCommunityCreateUpdateHeading">
            <Translate contentKey="tinyMedicRestApp.paymentCommunity.home.createOrEditLabel">Create or edit a PaymentCommunity</Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="payment-community-id"
                  label={translate('tinyMedicRestApp.paymentCommunity.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.paymentCommunity.name')}
                id="payment-community-name"
                name="name"
                data-cy="name"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.paymentCommunity.description')}
                id="payment-community-description"
                name="description"
                data-cy="description"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.paymentCommunity.active')}
                id="payment-community-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.paymentCommunity.cursor')}
                id="payment-community-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.paymentCommunity.lastUpdated')}
                id="payment-community-lastUpdated"
                name="lastUpdated"
                data-cy="lastUpdated"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.paymentCommunity.microSec')}
                id="payment-community-microSec"
                name="microSec"
                data-cy="microSec"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.paymentCommunity.timestampEntry')}
                id="payment-community-timestampEntry"
                name="timestampEntry"
                data-cy="timestampEntry"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                id="payment-community-hospital"
                name="hospital"
                data-cy="hospital"
                label={translate('tinyMedicRestApp.paymentCommunity.hospital')}
                type="select"
                required
              >
                <option value="" key="0" />
                {hospitals
                  ? hospitals.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <FormText>
                <Translate contentKey="entity.validation.required">This field is required.</Translate>
              </FormText>
              <ValidatedField
                id="payment-community-institution"
                name="institution"
                data-cy="institution"
                label={translate('tinyMedicRestApp.paymentCommunity.institution')}
                type="select"
              >
                <option value="" key="0" />
                {hospitalInstitutions
                  ? hospitalInstitutions.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/payment-community" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default PaymentCommunityUpdate;
